/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Records } from "./Records";
import { CellValue } from "./CellValue";
export const CellValueWithLinks = core.serialization
    .object({
    links: Records.optional(),
})
    .extend(CellValue);
